import { getFormattedDate } from '@/utils/date.utils';
import { RegisteredUserCard } from '../RegisteredUserCard';
import { TUserSchema } from '@/schemas/user/user.schema';

interface RegisteredUserListProps {
  data: TUserSchema[];
}

export const RegisteredUserList = ({ data }: RegisteredUserListProps) => {
  const renderCompanyNames = (user: TUserSchema) => {
    if (!user?.entityRoles?.length) {
      return <></>;
    }

    const uniqueCompanyNames = Array.from(
      new Set(
        user?.entityRoles?.map((role) => role?.company?.name)?.filter(Boolean)
      )
    );

    if (!uniqueCompanyNames?.length) {
      return <></>;
    }

    return (
      <div className="flex items-center gap-2 flex-wrap">
        {uniqueCompanyNames?.map((companyName, index) => (
          <span key={index} className="flex items-center gap-2">
            <span>{companyName}</span>
            {index < uniqueCompanyNames?.length - 1 && (
              <span className="text-gray-400">|</span>
            )}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-4">
      {data?.map((user) => (
        <RegisteredUserCard
          key={user?.id}
          linkTo={`/user/edit/${user?.id}`}
          avatarUrl={user?.profilePicture}
          fullName={`${user?.firstname} ${user?.lastname}`}
          companyName={renderCompanyNames(user)}
          registrationDate={getFormattedDate(user?.['createdAt'])}
          email={user?.email}
          phone={user?.phone}
        />
      ))}
    </div>
  );
};
